import React from 'react'
import DOMPurify from 'dompurify'

const SanitizeHtml = ({ html, tag: Tag = 'div', className, htmlFor }) => {
  if (!html) return <></>
  const body = DOMPurify.sanitize(html ?? '')

  return (
    <Tag
      htmlFor={htmlFor}
      className={className}
      dangerouslySetInnerHTML={{ __html: body }}
    />
  )
}

export default SanitizeHtml
